import { mapEnumToOptions } from '@abp/ng.core';

export enum ProjectTaxInvoiceStatus {
  InProgress = 0,
  Approved = 1,
}

export const projectTaxInvoiceStatusOptions = mapEnumToOptions(ProjectTaxInvoiceStatus);
